export default __webpack_public_path__ + "img/recyclable-packaging.0.asset.8991b3ca.jpg";